import type { FC } from 'react';

import { StackContainer } from '@eneco/custom-components/selfservice';
import { Stack, SkipToMain, Grid, Stretch } from '@eneco/sparky';
import { Placeholder } from '@sitecore/common';

const DefaultLayout: FC = () => (
  <>
    <Placeholder name="jss-meta" />

    <StackContainer>
      <>
        <SkipToMain.SkipLink targetId="hero-card" />
        <header>
          <Placeholder name="jss-header" />
          <Placeholder name="jss-navigationbar" />
          <Placeholder name="jss-notifications" />
          <Placeholder name="jss-grootzakelijk-notifications" />
        </header>

        <Stack.Item grow>
          <Stretch>
            <Grid gridTemplateColumns="1fr" gridTemplateRows="1fr" gridTemplateAreas="none">
              <SkipToMain.Main>
                <Placeholder name="jss-main" />
              </SkipToMain.Main>
            </Grid>
          </Stretch>
        </Stack.Item>

        <footer>
          <Placeholder name="jss-footer" />
        </footer>
      </>
    </StackContainer>
  </>
);

export default DefaultLayout;
